import { useState, useEffect } from 'react';

const useLocalStorage = (keys: Array<string>, onSuccess: Function, onError?: Function) => {
    const [item, setItem] = useState(null);

    useEffect(() => {
        const items = keys.map((key) => window.localStorage.getItem(key));
        // console.log('localStorageToken -', i);
        // @ts-ignore
        setItem(...items);
        if (items.length <= 0 && onError) onError();
        if (items.length > 0) {
            onSuccess(...items);
        }
    }, []);

    return item;
};


export default useLocalStorage;